import { useEffect } from 'react';
import { doTagLogoutView } from '../tagging';

export const useRecordPageLogoutView = ({ products, userProfile, setPageName }) => {
    useEffect(() => {
        setPageName(doTagLogoutView({ products, userProfile }));
    }, []);
};
